import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';


const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 0,
    }
};

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        funGetProducts(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map((product ) =>{
                return{
                    ...product,
                    devDt: m.date({ value: product.devDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const productActions = productSlice.actions;
export default productSlice.reducer;